import React, { Component } from "react";
import { HubConnectionState } from "@microsoft/signalr";

import { withCars } from "./../../../shared/containers/containerCars";
import { withFilterCars } from "./../../../shared/containers/containerFilterCars";
import { withSetCarBookmark } from "./../../../shared/containers/containerSetCarBookmark";
import { withDeleteCarBookmark } from "./../../../shared/containers/containerDeleteCarBookmark";
import { withMainMap } from "./../../../shared/containers/containerMainMap";

import Preloader from "./../../../shared/items/static/preloader";
import Notification from "./../../../shared/items/static/notification";
import CarsListItems from "./сarsListItems";

import { states } from "./../../../reducers/queriesStates";

import "./carsList.module.scss";
import styles from "./carsList.module.scss";
import { withSignalR } from "../../../shared/containers/containerSignalR";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { unitFilterService } from "./unitFilterService";

class CarsList extends Component {
  componentDidMount() {
    unitFilterService.didMount(this.props);
  }

  componentWillUnmount() {
    const { onStopConnect, connectionSR } = this.props;

    if (!!connectionSR) onStopConnect(connectionSR);

    unitFilterService.clearTimeoutConnection();
  }

  componentDidUpdate(prevProps) {
    unitFilterService.didUpdate(prevProps, this.props);
  }

  render() {
    const { handleScrollTo, listUnits, dataStateUnits } = this.props;

    if (dataStateUnits === states.REQUEST)
      return (
        <div className={styles.container_preloader}>
          <Preloader />
        </div>
      );

    return (
      <React.Fragment>
        <div className={styles.carsList_wrapper}>
          {listUnits.length > 0 ? (
            <div className={styles.carsList}>
              <CarsListItems data={listUnits} handleScrollTo={handleScrollTo} />
            </div>
          ) : (
            <Notification type="warning">
              <p>По данным параметрам поиска автомобили не найдены.</p>
            </Notification>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default withWinterMaintence(
  withAuth(withSignalR(withMainMap(withCars(withFilterCars(withSetCarBookmark(withDeleteCarBookmark(CarsList)))))))
);
